module.exports = __webpack_public_path__ + "img/icon_mypage_color.ed95a1ea.svg";